module.exports = __webpack_public_path__ + "assets/img/e4e6e3ea116e34c8719035cc51fa556b.svg";